import React from 'react';
import PropTypes from 'prop-types';
import Color from '../../Color';

class Templates extends React.Component {
    renderTemplate(template) {
        const isActive = this.props.activeTemplate === template.id;
        const classes = ['menu__item'];

        if (isActive) {
            classes.push('menu__item--active');
        }

        return (
            <li
                className={classes.join(' ')}
                key={template.id}
                onClick={() => this.props.setActiveTemplate(template.id)}
            >
                <Color color={template.colors.primary} secondaryColor={template.colors.secondary} />
            </li>
        );
    }

    render() {
        const { templates } = this.props;
        return (
            <div className="submenu__row template-selection">
                <ul className="menu">
                    {Object.keys(templates).map(key => this.renderTemplate(templates[key]))}
                </ul>
            </div>
        );
    }
}

Templates.propTypes = {
    templates: PropTypes.object.isRequired,
    activeTemplate: PropTypes.number,
    setActiveTemplate: PropTypes.func.isRequired,
};

Templates.defaultProps = {
    activeTemplate: null,
};

export default Templates;
